import { state, props } from 'cerebral/tags'
import { setField } from '@cerebral/forms/operators'

export default [setField(state`node.panel.name`, props`value`)]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/onChangeNodeName.js